import { AreasList } from 'components/areasManagement'
import { usePageAccess } from 'hooks'
import { Helmet } from 'react-helmet'

const AreasManagement = () => {
  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Areas Management</title>
      </Helmet>
      <div className="h-full max-h-[600px]  overflow-y-scroll border">
        <AreasList isEditor={isEditor} />
      </div>
    </>
  )
}

export default AreasManagement
